import { render, staticRenderFns } from "./PhysicianProfile.vue?vue&type=template&id=b4c99db6&scoped=true&"
import script from "./PhysicianProfile.vue?vue&type=script&lang=js&"
export * from "./PhysicianProfile.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianProfile.vue?vue&type=style&index=0&id=b4c99db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c99db6",
  null
  
)

component.options.__file = "PhysicianProfile.vue"
export default component.exports